import React from 'react';
import { Box, Container, Typography, Link, IconButton } from '@mui/material';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';

export default function Footer() {
    return (
        <Box
            component="footer"
            sx={{
                py: 3,
                px: 2,
                mt: 'auto',
                textAlign: 'center',
            }}
        >
            <Container maxWidth="lg">
                {/* Links para redes sociais */}
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 1 }}>
                    <IconButton
                        color="inherit"
                        component="a"
                        href="https://www.linkedin.com/in/italo-de-matos/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <LinkedInIcon />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        component="a"
                        href="https://github.com/itMatos"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <GitHubIcon />
                    </IconButton>
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mb: 2 }}>
                    <Link href="#about" color="textSecondary" underline="hover">
                        Sobre
                    </Link>
                    <Link href="#projects" color="textSecondary" underline="hover">
                        Projetos
                    </Link>
                    <Link href="#contact" color="textSecondary" underline="hover">
                        Contato
                    </Link>
                </Box>

                {/* Informações de copyright */}
                <Typography variant="body2" color="textSecondary">
                    © {new Date().getFullYear()} Italo Matos. Todos os direitos reservados.
                </Typography>
            </Container>
        </Box>
    );
}
